import {Injectable, Optional} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';
import {ReplaySubject} from 'rxjs/ReplaySubject';


// Providers.
import {WABaseService} from './wa-base.service';
import {LoggerService} from '../logger/logger-service';
import {EnvironmentService} from './environment-service';
import {DataFetchService} from './data-fetch-service';
import {FactoryService} from './factory-service';
import {ViewDataService} from './view-data-service';


// Interfaces.
import {StorageInterface, StorageInterfaceImpl} from '../interfaces/storage.interface'

@Injectable()
export class StateBaseService extends WABaseService {

  protected readyStream: ReplaySubject<boolean>;

  constructor(public logger: LoggerService,
    protected env: EnvironmentService,
    protected fetcher: DataFetchService,
    protected factory: FactoryService,
    protected viewData: ViewDataService,
    public storage: StorageInterfaceImpl) {
    super(logger, env);

    this.readyStream = new ReplaySubject<boolean>(1);
    this.readyStream.next(false);


    Observable.fromPromise(storage.ready())
      .subscribe((x) => {
        this.log('Storage system is ready', x);
        this.readyStream.next(true);
      },
      () => {
        this.error('Error initializating storage system')
        // @TODO: Launch fatal exception, app can't work without this.
      });
  }

  public isReady(): Observable<boolean> {
    return this.readyStream.asObservable();
  }

  protected get(key: string, defaultValue: any = null): Observable<any> {
    return Observable.fromPromise(this.storage.get(key))
      .catch(() => Observable.of(defaultValue));
  }

  protected set(key: string, value: any): Observable<any> {
    return Observable.fromPromise(this.storage.set(key, value));
  }
}
